import { faPlus, faTrash, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { useFormikContext } from "formik";
import { cloneDeep } from "lodash";
import React, { useState } from "react";
import { Button } from "react-bootstrap";

import { TDSTaxesCollectedAtSourceDetailsForm } from ".";
import { IFormITR1, ITaxesCollectedAtSources } from "../../../config/interfaces";
import FASvgIcon from "../../FASvgIcon";
import PreventEditComponent from "../../PreventEditComponent";
import PriceDisplay from "../../PriceDisplay";
import { ConfirmationModal } from "../../modals";

const TDSTaxesCollectedAtSourceDetails: React.FC = () => {
  const { values, setFieldValue } = useFormikContext<IFormITR1>();

  const [showAddFormCanvas, setShowAddFormCanvas] = useState<boolean>(false);
  const [showDeleteModal, setShowDeleteModal] = useState<ITaxesCollectedAtSources | null>(null);
  const [activeItem, setActiveItem] = useState<ITaxesCollectedAtSources | null>(null);
  // used in both edit and delete cases
  const [activeItemIdx, setActiveItemIdx] = useState<string>("");

  const CollectedAtSources = cloneDeep(values.TaxesPaidTDSandTCS?.TaxesCollectedAtSources || []);

  const handleDeleteItem = async () => {
    CollectedAtSources.splice(Number(activeItemIdx), 1);
    setFieldValue("TaxesPaidTDSandTCS.TaxesCollectedAtSources", CollectedAtSources);
    setShowDeleteModal(() => null);
    setActiveItem(() => null);
    setActiveItemIdx(() => "");
    handleTotalCalculation();
  };

  const handleTotalCalculation = () => {
    const _TotalSchTCS =
      CollectedAtSources?.reduce((acc, curr) => {
        const value = Number(curr.TaxCollectedClaimedForThisYear);
        return acc + (isNaN(value) ? 0 : value);
      }, 0) || 0;

    setFieldValue("TotalSchTCS", _TotalSchTCS);
    setFieldValue("TaxesPaidTDSandTCS.TaxesCollectedAtSources", CollectedAtSources);
  };

  return (
    <>
      <section className="mb-5">
        <div className="section-title-wrap">
          <h5>
            Taxes collected at source
            <small>Add all the TCS entries for ex : on purchase of cars</small>
          </h5>
          <PreventEditComponent>
            <Button variant="secondary" size="sm" onClick={() => setShowAddFormCanvas(() => true)}>
              <FASvgIcon icon={faPlus} />
              Add
            </Button>
          </PreventEditComponent>
        </div>

        <dl className="eds-list eds-dl eds-inline-between">
          {CollectedAtSources?.map((tds, index) => (
            <div key={`sale-rent-deduction-${index}`} className="eds-list--item">
              <dt>{tds.CollectorName}</dt>
              <dd>
                <span>
                  <PriceDisplay price={parseInt(tds?.TaxCollectedClaimedForThisYear || "0")} />
                </span>
                <Button
                  variant="link"
                  onClick={() => {
                    setShowAddFormCanvas(() => true);
                    setActiveItem(() => tds);
                    setActiveItemIdx(() => String(index));
                  }}
                >
                  View
                  <PreventEditComponent>
                    <>/Edit</>
                  </PreventEditComponent>
                </Button>
                <Button
                  variant="transparent"
                  className="icon-only"
                  onClick={() => {
                    setShowDeleteModal(() => tds);
                    setActiveItemIdx(() => String(index));
                  }}
                >
                  <FASvgIcon icon={faTrash} />
                </Button>
              </dd>
            </div>
          ))}
        </dl>
      </section>

      <TDSTaxesCollectedAtSourceDetailsForm
        showCanvas={showAddFormCanvas}
        handleCloseBtnPress={(tdsData) => {
          if (tdsData) {
            if (activeItem) {
              CollectedAtSources.splice(Number(activeItemIdx), 1, tdsData);
            } else {
              CollectedAtSources.push(tdsData);
            }
            handleTotalCalculation();
          }
          setShowAddFormCanvas(() => false);
          setActiveItem(() => null);
          setActiveItemIdx(() => "");
        }}
        formValues={activeItem}
      />

      <ConfirmationModal
        showModal={!!showDeleteModal}
        iconColorClass="text-danger"
        title="Are you sure?"
        message={<p>You want to delete {showDeleteModal?.CollectorName}</p>}
        onYesBtnClick={() => handleDeleteItem()}
        onNoBtnClick={() => setShowDeleteModal(() => null)}
        icon={faTrashAlt}
      />
    </>
  );
};

export default TDSTaxesCollectedAtSourceDetails;
